import { handleActions } from 'redux-actions';

import WixSDK from 'shared/utils/wix-sdk';

import defaultLocale from 'shared/constants/default-locale';


let locale;
try {
  locale = WixSDK.Utils.getLocale() || defaultLocale;
} catch (error) {
  locale = defaultLocale;
}

export default handleActions({}, locale);



// WEBPACK FOOTER //
// ./src/shared/redux/client/reducers/locale.js